<template>
  <div class="rank_cell after_border">
    <img v-lazy="data.user.avatar_url" class="headimg">
    <div class="username">
      <div>{{ data.user.nickname }}</div>
      <div v-if="isManager" style="padding-top: 2px; margin-left: 5px;">
        <a :href="'tel:' + data.user.mobile + '#mp.weixin.qq.com'"><van-icon name="phone-o" /></a>
      </div>
    </div>
    <div class="times">
      <div style="margin-bottom:3px;">{{data.distance}}km</div>
      <van-tag v-if="data.is_complete" type="success">已完成</van-tag>
      <van-tag v-else type="">未完成</van-tag>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Tag, Icon } from 'vant'

export default {
  name: 'DayStatCell',
  components: {
    [Icon.name]: Icon,
    [Tag.name]: Tag
  },
  props: {
    rankCode: {
      type: String,
      default: 'day'
    },
    data: {
      type: Object,
      default () {
        return null
      }
    },
    isManager: {
      type: Number,
      default: 0
    }
  },
  filters: {
    rankLabel (value) {
      if (value === 'day') {
        return '天'
      } else if (value === 'distance') {
        return '公里'
      } else if (value === 'duration') {
        return ''
      } else if (value === 'pace') {
        return ''
      } else if (value === 'num') {
        return '次'
      }
      return ''
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'userprofile'
    ])
  },
  created () {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.rank_cell {
  font-size: 26px;
  padding: 0 30px;
  height: 110px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .idx {
    font-size: 26px;
    width: 40px;
    &.rank1 {
      color: #ffdc7b;
      font-weight: bold;
      font-size: 30px;
    }
    &.rank2 {
      color: #d8efed;
      font-weight: bold;
      font-size: 30px;
    }
    &.rank3 {
      color: #f6d6bc;
      font-weight: bold;
      font-size: 30px;
    }
  }
  .headimg {
    width: 77px;
    height: 77px;
    border-radius: 50%;
  }
  .username {
    font-size: 28px;
    width: 450px;
    display: flex;
  }
  .times {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #8d8d8d;
  }
}
</style>
